var completeSystemSlider = {
  init: function init() {
    var $completeSystemSlider = $('.js-complete-system-slider');
    var options;
    if ($completeSystemSlider.length === 0) {
      return;
    }
    $.each($completeSystemSlider, function () {
      var $completeSystemSliderInstance = $(this);
      var $sliderLength = $completeSystemSliderInstance.find('.checkout-system-slider-item ').length;
      if ($sliderLength <= 2) {
        options = {
          cellAlign: 'left',
          prevNextButtons: false,
          pageDots: false,
          dragThreshold: 10,
          wrapAround: false,
          contain: true,
          draggable: true,
          on: {
            ready: function ready() {
              $completeSystemSliderInstance.removeClass('invisible');
            }
          }
        };
      } else {
        options = {
          cellAlign: 'left',
          prevNextButtons: true,
          pageDots: false,
          dragThreshold: 10,
          wrapAround: false,
          contain: true,
          on: {
            ready: function ready() {
              $completeSystemSliderInstance.removeClass('invisible');
            }
          }
        };
      }
      $completeSystemSliderInstance.flickity(options);
    });
  }
};
export default completeSystemSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/complete-system.js